
import React, { useState, useEffect, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import copy from "copy-to-clipboard";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { BsSearch } from "react-icons/bs";
import ThemeControls from "../Component/AllThemesControl.js";
import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import TableSortLabel from '@mui/material/TableSortLabel';
import Loading from '../images/Table/Loading.gif';
// import { FormJSONCreateContext } from '../FormJSONCreateContext.js';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { visuallyHidden } from '@mui/utils';
import { FormContext } from '../Component/Forms/FormContext.js';
import Element from "./Element.js"
import * as XLSX from 'xlsx';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
// import { Alert } from 'react-bootstrap';



//testing
//import SuccessPage from '../SuccessPage'
//JSON CONTEXT

//APISERVICES
import { APIGET, APIDEL, APIPATCH, APIPOST } from '../services/APIServices.js';
//import SuccessPage from '../SuccessPage';

//Navigation
import { useNavigate, Link } from 'react-router-dom';
import { render } from '@testing-library/react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const _columns = [
    {
        "key": "1",
        "title": "Name",
        "dataIndex": "name"
    },
    {
        "key": "2",
        "title": "Tech Prefix",
        "dataIndex": "techPrefix"
    },
    {
        "key": "3",
        "title": "Breakout",
        "dataIndex": "breakout"
    },
    {
        "key": "4",
        "title": "Quality",
        "dataIndex": "quality"
    },
    {
        "key": "5",
        "title": "Rate",
        "dataIndex": "rate"
    },
    {
        "key": "6",
        "title": "Date",
        "dataIndex": "startDate"
    }
]

//Rendering Rows
function RenderRow(props) {
    const { row, index, dataSource, editJson, editRowOpen, selected, setEditJson, handleClick } = props
    if (index < dataSource.length) {
        let arr = row;
        const postData = arr
        let keys = _columns?.map((column) => ({
            dataIndex: column.dataIndex,
            field_type: column.field_type,
        }));


        function setDataOnEdit() {
            const updatedEditJson = { ...editJson };

            updatedEditJson.fields = updatedEditJson.fields.map((field) => {
                if (field.field_id in arr) {

                    return { ...field, field_value: arr[field.field_id] };
                }
                return field;
            });

            setEditJson(updatedEditJson);
        }



        // 
        const isSelected = (name) => selected.indexOf(name) !== -1;
        const isItemSelected = isSelected(row);

        const labelId = `enhanced-table-checkbox-${index}`;

        function tablecellValue(key) {
            if (typeof key === 'string') {
                return arr[key]
            } else if (Array.isArray(key)) {
                let value = "";
                for (const item of key) {
                    if (item.column) {
                        value += String(arr[item.column] || '');
                    } else if (item.condition) {
                        value += eval(item.condition);
                    } else if (item.string) {
                        value += item.string;
                    }
                }
                return value;
            } else {
                // It is neither a string nor an array.
                return null; // Set the return value to null explicitly.
            }
        }
        // console.log(tablecellValue('allocation'))
        const handleChange = (id, event, value) => {
            const updatedEditJson = { ...editJson };

            updatedEditJson.fields = updatedEditJson.fields.map((field) => {
                if (id === field.field_id) {
                    //console.log(value)
                    postData[field.field_id] = value;
                    return { ...field, field_value: value };
                }
                return field;
            });

            setEditJson(updatedEditJson);
        };
        // console.log(keys.map((key) => arr[key.dataIndex]))
        return (
            <React.Fragment>
                <TableRow
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                >
                    <StyledTableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            onClick={(event) => handleClick(event, row)}
                            inputProps={{
                                'aria-labelledby': labelId,
                            }}
                        />
                    </StyledTableCell>
                    {keys?.map((key) => (
                        <StyledTableCell value={String(arr[key.dataIndex])}>
                            {
                                key.field_type && editRowOpen === index ?
                                    <FormContext.Provider value={{ handleChange }}>
                                        {editJson.fields && editJson.fields.map((field, i) => {
                                            if (field.field_id === key.dataIndex) {
                                                return (<Element key={i} field={field} />)
                                            }
                                        })
                                        }
                                    </FormContext.Provider> :
                                    <div style={{ display: 'flex' }}>
                                        <span></span>
                                        <div>{tablecellValue(key.dataIndex)}</div>
                                    </div>
                            }
                        </StyledTableCell>
                    ))}
                </TableRow>
            </React.Fragment>
        );
    }
}

function EnhancedTableToolbar(props) {
    const { numSelected, filteredData, setDataSource } = props;
    const { useStyles } = ThemeControls;
    const classes = useStyles();
    const [searchValue, setSearchValue] = useState('');
    const handleInputChange = (e) => {
        const value = e.target.value
        setSearchValue(value);

        if (value) {
            const filteredResult = filteredData.filter((item) => {
                return Object.keys(item).some((key) =>
                    String(item[key]).toLowerCase().includes(value.toLowerCase())
                );
            });
            setDataSource(filteredResult)
        } else {
            setDataSource(filteredData)
        }
    }

    return (
        <Toolbar
            sx={{
                mt: 3,
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
            >
                <div className={classes.filtersearch}>
                    <input id="searchInputDataTable" type="text" onChange={handleInputChange} className={classes.searchInput} placeholder="Search" />
                    {/* <IconButton> */}
                    <div>
                        <BsSearch />
                    </div>
                    {/* </IconButton> */}
                </div>
            </Typography>
            {numSelected > 0 && (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {numSelected} selected
                </Typography>
            )}
        </Toolbar>
    );
}

export default function Details(obj) {
    const { useStyles } = ThemeControls;
    const classes = useStyles();
    const field_option_src = obj.field_option_src;
    const [dataSource, setDataSource] = useState([]);
    const unqId = 'vendorId'
    const [open, setOpen] = React.useState(false);

    const [editRowOpen, setEditRowOpen] = React.useState(false);
    const [noData, setNoData] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState('');
    const [tyepMsg, setTypeMsg] = React.useState('error');
    // const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [selected, setSelected] = React.useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [loading, setLoading] = useState(true);
    const [editJson, setEditJson] = useState(obj.EditJson);
    const [refresh, setRefresh] = useState(false)
    const isDisabled = dataSource.length === 0;


    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const formFieldsJson = obj.createJson;
    //Setting_data for view table.===>
    let navigate = useNavigate();
    useEffect(() => {
        let initialRender = true;
        async function settingData(props) {
            const url = props.field_option_src_context + `/` + props.field_option_src_critieria;
            return await APIGET(url).then(data => {
                try {
                    if (data.data) {
                        if (Array.isArray(data.data)) {
                            setDataSource(data.data);
                            setFilteredData(data.data);
                        } else if (typeof data.data === 'object') {
                            setDataSource([data.data]);
                            setFilteredData([data.data]);
                        } else {
                            console.log("The data is neither an array nor an object.");
                        }
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setLoading(false);
                }
            })
        }

        if (field_option_src.field_option_src_critieria) {
            settingData(field_option_src);
        }
    }, [])

    // console.log(dataSource)  

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }


    const handleInputChange = (e) => {
        let value = e.target.value
        // setSearchValue(e.target.value);
        document.getElementById('searchInputDataTable').value = value;

    }

    function searchdata() {
        const searchValue = document.getElementById('searchInputDataTable').value
        if (searchValue) {
            const filteredResult = filteredData.filter((item) => {
                return Object.keys(item).some((key) =>
                    String(item[key]).toLowerCase().includes(searchValue.toLowerCase())
                );
            });
            console.log(filteredResult)
            if (filteredResult.length > 0) {
                setDataSource(filteredResult)
            } else {
                alert('No Record Found')
            }
        }
    }

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSource.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            stableSort(dataSource, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, dataSource],
    );

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    console.log(selected)
    // const validateTechPrefix = (data) => {
    //     let techPrefixMap = {}; // Object to store unique techPrefix for each vendorId

    //     for (let i = 0; i < data.length; i++) {
    //       const item = data[i];
    //       const { vendorId, techPrefix, breakout, name } = item; // Include 'name' and 'breakout' for the alert message

    //       if (!techPrefixMap[vendorId]) {
    //         techPrefixMap[vendorId] = new Set(); // Initialize Set for unique techPrefix
    //       }

    //       // Check if techPrefix is already present for the same vendorId and breakout
    //       if (techPrefixMap[vendorId].has(`${breakout}-${techPrefix}`)) {
    //         alert(`Please choose a different Techprefix for vendor '${name}' with breakout '${breakout}'.`);
    //         return false; // Validation fails if techPrefix is not unique for a vendorId and breakout
    //       }

    //       techPrefixMap[vendorId].add(`${breakout}-${techPrefix}`); // Add techPrefix to Set
    //     }

    //     return true; // Validation passes if all techPrefix values are unique for each vendorId and breakout
    //   };

    const validateTechPrefix = (Mbreakout, selected) => {
        let vendorBreakoutMap = {};
        let selectedBreakouts = new Set(selected.map(item => item.breakout.toUpperCase().trim()));

        for (let vendor of selected) {
            let key = vendor.vendorId + "-" + vendor.breakout.trim(); // Use vendorId instead of name for uniqueness

            // Check for duplicate techprefix
            if (!vendorBreakoutMap[key]) {
                vendorBreakoutMap[key] = new Set();
            }
            let techPrefixTrimmed = vendor.techPrefix.trim();
            if (vendorBreakoutMap[key].has(techPrefixTrimmed)) {
                setErrorOpen(true)
                setTypeMsg('error')
                setErrorMsg(`Please choose different Techprefix for ${vendor.name} and breakout ${vendor.breakout}.`);
                return false;
            }
            vendorBreakoutMap[key].add(techPrefixTrimmed);
        }

        // Check if all breakouts from Mbreakout are present in selected items
        for (let brkout of Mbreakout) {
            if (!selectedBreakouts.has(brkout.toUpperCase().trim())) {
                setErrorOpen(true)
                setTypeMsg('error')
                setErrorMsg(`Please Select Vendor for ${brkout} breakout.`);
                return false;
            }
        }

        return true;
    };


    const showVendorDetails = () => {
        const vendordetailArr = [];
        const Mbreakout = field_option_src.field_temp.split(', ');
        const otherAndRocBreakouts = [];



        Mbreakout.forEach(brkout => {
            if (brkout.toUpperCase() === "OTHER" || brkout.toUpperCase() === "ROC") {
                selected.forEach(vendor => {
                    if (vendor.breakout.toUpperCase().includes("ROC") || vendor.breakout.toUpperCase().includes("OTHER")) {
                        vendordetailArr.push(vendor);
                    }
                });
            }
        });

        selected.forEach(vendor => {
            if (vendor.breakout.toUpperCase().includes("ROC") || vendor.breakout.toUpperCase().includes("OTHER")) {
                otherAndRocBreakouts.push(vendor);
            } else {
                vendordetailArr.push(vendor);
            }
        });

        otherAndRocBreakouts.forEach(vendor => {
            Mbreakout.forEach(brkout => {
                if (brkout.toUpperCase() !== "OTHER" && brkout.toUpperCase() !== "ROC") {
                    let newVendor = { ...vendor, breakout: brkout };
                    vendordetailArr.push(newVendor);
                }
            });
        });

        return vendordetailArr;
    };


    function handleSubmit() {

        const Mbreakout = field_option_src.field_temp.split(', ');
        if (selected.length > 0) {
            const isValid = validateTechPrefix(Mbreakout, selected);
            if (isValid) {
                obj.setSelectedvendor(1)
                obj.setDataSource(showVendorDetails())
                obj.setFilteredData(showVendorDetails())
                obj.setReplicate(showVendorDetails())
                obj.close()
            }
        } else {
            setErrorOpen(true)
            setTypeMsg('error')
            setErrorMsg("Please select vendor with Techprefix");
        }

    }

    const handleClose = () => {
        setErrorOpen(false);
    };
    
    const handleCloseVendor = () => {
        setSelected([])
        obj.close()
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = dataSource.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    return (
        <React.Fragment>
            <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={errorOpen} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={tyepMsg} sx={{ width: '100%' }}>
                    {errorMsg}
                </Alert>
            </Snackbar>

            <Dialog className={classes.popupEdit}
                // fullScreen
                open={open}
                maxWidth="md"
                aria-labelledby="responsive-dialog-title"
            >

            </Dialog>

            <div className={`${loading ? classes.slctVndr : classes.detailsPopup}`}>
                <div className={classes.headerSticky}>
                    <CloseIcon onClick={handleCloseVendor} />
                    <h4>Select Vendor</h4>
                </div>
                <div>
                    {loading ?
                        <div className={classes.loader}>
                            <img src={Loading} alt="Loading..." />
                        </div> :
                        <>
                            <EnhancedTableToolbar numSelected={selected.length} filteredData={filteredData} setDataSource={setDataSource} />
                            <TableContainer className={classes.table}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell padding="checkbox">
                                                <Checkbox
                                                    color="primary"
                                                    indeterminate={selected.length > 0 && selected.length < dataSource.length}
                                                    checked={dataSource.length > 0 && selected.length === dataSource.length}
                                                    onChange={handleSelectAllClick}
                                                    inputProps={{
                                                        'aria-label': 'select all desserts',
                                                    }}
                                                />
                                            </StyledTableCell>
                                            {_columns?.map((column, i) => (<StyledTableCell
                                                // key={i}
                                                // align={column.numeric ? 'right' : 'left'}
                                                // padding={column.disablePadding ? 'none' : 'normal'}
                                                sortDirection={orderBy === column.dataIndex ? order : false}
                                            >
                                                <TableSortLabel
                                                    active={orderBy === column.dataIndex}
                                                    direction={orderBy === column.dataIndex ? order : 'asc'}
                                                    onClick={createSortHandler(column.dataIndex)}
                                                >
                                                    {column.title}
                                                    {orderBy === column.dataIndex ? (
                                                        <Box component="span" sx={visuallyHidden}>
                                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                        </Box>
                                                    ) : null}
                                                </TableSortLabel>
                                            </StyledTableCell>
                                            ))}
                                            {/* <StyledTableCell>ACTION</StyledTableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dataSource.length === 0 ? <td style={{ textAlign: 'center' }} colSpan={_columns.length + 1}>No Data</td> :
                                            visibleRows.map((arr, index) => (
                                                <RenderRow row={arr} index={index} dataSource={dataSource} editJson={editJson} editRowOpen={editRowOpen} selected={selected} setEditJson={setEditJson} handleClick={handleClick} />
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className={classes.pagination}>
                                <TablePagination
                                    component="div"
                                    labelRowsPerPage='Show row per page'
                                    count={dataSource.length}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={[10, 50, 100, 500]}
                                />
                            </div>
                        </>
                    }
                </div>
            </div>
            <DialogActions>
                {selected.length > 0 && <Button onClick={handleSubmit}>Submit</Button>}
                <Button onClick={handleCloseVendor}>Close</Button>
            </DialogActions>
        </React.Fragment>
    );
}
